module.exports = __webpack_public_path__ + "img/parcel.cf0562db.svg";